'use client';

import React from 'react';
import Link from 'next/link';

import { FOOTER_LINKS } from '@/constants/downloadApp';

import classes from '../../index.module.css';
import DownloadCTA from '../DownloadCTA';
import Faq from '../Faq';
import Features from '../Features';
import Hero from '../Hero';
import Reviews from '../Reviews';
import Screenshots from '../Screenshots';
import Stats from '../Stats';

const DownloadAppLanding = () => {
    return (
        <main className={`${classes.root} min-h-screen`}>
            <Hero />
            <Stats />
            <Features />
            <Screenshots />
            <Reviews />
            <Faq />
            <div id='download'>
                <DownloadCTA />
            </div>
            <footer className='border-t border-white/10 px-4 py-8 text-center text-[11px] text-whiteMediumEmphasis'>
                <nav className='desktop-width mb-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 md:px-8' aria-label='خدمات مرتبط'>
                    {FOOTER_LINKS.map((link) => (
                        <Link key={link.id} href={link.href} className='text-xs text-whiteMediumEmphasis transition hover:text-white'>
                            {link.label}
                        </Link>
                    ))}
                </nav>
                <p className='m-0'>تمامی حقوق مادی و معنوی این سرویس متعلق به ازکی‌سرویس است.</p>
            </footer>
        </main>
    );
};

export default DownloadAppLanding;
